/**
 * in case that API returns time in the past, change it to now
 * @param earliestPickup
 */
export const getEarliestPickupDate = (earliestPickup: Date) => {
  const now = new Date();
  return earliestPickup > now ? earliestPickup : now;
};
